<template>
  <component
    :is="tag"
    class="card"
    :class="{teaser: !hasAction}"
    :attr-global-id="product.globalId"
    :attr-product-id="product.id"
  >
    <div
      class="card--images"
      :class="`decors-produit-background-${product.bg ? product.bg : 'defaut'}`"
    >
      <HeadlinesBanner
        v-if="isNew"
        class="card--images--isnew"
        :items="[$config.common.newProduct]"
      />
      <div
        v-if="product.logo"
        class="card--images--logo decors-produit-coin-droit"
      >
        <div
          class="logo"
          :class="`decors-produit-logo-${product.logo}`"
        />
      </div>
      <div
        class="card--images--character"
        :class="`decors-produit-${product.id}`"
      />
      <component
        :is="hasAction ? 'router-link' : 'div'"
        class="card--images--link"
        :to="`zoom/${product.id}`"
      >
        <div
          class="card--images--head"
          :class="`coin-product-${product.id}`"
        />
      </component>
      <div
        v-if="hasAction"
        class="card--images__zoom-cta decors-icons-loupe"
      />
      <div
        class="card--images--tails"
        :class="[{box: product.box},`coin-product-revers-${product.value}`]"
      />
      <div
        v-if="!product.box"
        class="card--images--card"
        :class="`decors-produit-cartelettes-${product.id}`"
      />
      <div
        class="after decors-produit-coingauche"
      />
      <div
        v-if="!teaser"
        class="card--images-price"
      >
        {{ price }}
        <div class="after decors-produit-prix" />
      </div>
    </div>
    <div class="card--infos">
      <h4>{{ product.label }}</h4>
      <h5 v-if="product.name">
        {{ product.name }}
      </h5>
      <span>{{ product.details }}</span>
    </div>
    <ProductInfo
      v-if="!teaser"
      class="card--cta"
      :product="product"
    />
  </component>
</template>
<script>
import ProductInfo from '@/components/utils/product/ProductInfo.vue';
import HeadlinesBanner from '@/components/common/banner/HeadlinesBanner.vue';

export default {
  name: 'ProductCard',
  components: {
    ProductInfo,
    HeadlinesBanner,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    tag: {
      type: String,
      default: 'li',
    },
    teaser: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    price() {
      return `${this.product.price}`;
    },
    hasAction() {
      return !this.teaser;
    },
    isNew() {
      return (this.$currentWave > 1 && this.product.wave === this.$currentWave);
    },
  },
};
</script>
<style lang="stylus" scoped>
.card {
  --charOffset: 66px;
  display: flex;
  flex-direction: column;
  padding-bottom: 20px
  align-items: center;
  justify-content: flex-start
  gap: 15px;
  // width: calc(100vw - 10px);
  margin-top: var(--charOffset);
  &.teaser {
    pointer-events: none;
  }

  +desktop() {
    padding-bottom: 20px;
    // width: auto;
  }

  & > * {
    max-width: 384px;
    min-width: 355px;
  }

  &--images {
    position: relative;
    background-size: cover;
    cursor: pointer;
    +mobile() {
      width: 355px;
    }

    &--isnew {
      height: 38px;
      border-bottom: 1px solid black;
      margin-top: -38px;
    }

    +hover() {
      .card--images--character {
        transform: translateY(-10px);
      }
      .card--images--head {
        transform: scale(1.1) translateY(-50%);
      }
      .card--images__zoom-cta {
        transform: scale(1.2) translate(-5px, -5px);
      }

      .card--images--tails:not(.box) {
        opacity: 0
        transform: translateY(-10px)
      }

      .card--images--card:not(.box) {
        opacity: 1
        transform: translateY(0)
      }
    }

    +touchDevice(){
      --duration: 5s;
      @keyframes toggle {
        0%, 48% {
          transform: translateY(-10px);
          opacity: 0
        }
        52%, 100% {
          transform: translateY(0);
          opacity: 1
        }
      }
      .card--images--tails:not(.box) {
        animation: toggle var(--duration) infinite alternate;
      }

      .card--images--card:not(.box) {
        animation: toggle var(--duration) infinite alternate-reverse;
      }
    }

    &--link {
      display: block;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 3;
    }

    &--logo {
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      z-index: 1;
      aspect-ratio: 1 / 1;
      & .logo {
        position: absolute;
        top: 0
        right: 0
      }
    }

    &--character {
      display: block;
      position: absolute;
      top: calc(-1 * var(--charOffset));
      left: 0;
      z-index: 0;
      transition: transform 0.5s;
    }

    &--head {
      display: block;
      position: absolute;
      top: 50%;
      right: 20px;
      transform: translateY(-50%);
      z-index: 3;
      margin-top: 10px;
      transition: transform 0.5s;
      +mobile() {
        // right: 30px;
      }

    }

    &__zoom-cta {
      position: absolute;
      top: 64px;
      right: 200px;
      background-color: black;
      border-radius: 50%;
      background-position: center;
      width: 40px;
      height: auto;
      border: 1px solid $cl-yellow;
      z-index: 3;
      transition: all 0.5s ease-out;
      pointer-events: none;
      +mobile() {
        right: 180px;
      }
    }

    &--tails, &--card {
      display: block;
      position: absolute;
      bottom: 20px;
      left: 20px;
      z-index: 3;
      transition: all 0.5s ease-out;
      pointer-events: none;
    }

    &--card {
      opacity: 0;
      transform: translateY(10px);
    }

    & > .after {
      display: block;
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 1;
      width: 100%;
      height: auto;
      background-size: cover;
    }

    &-price {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      bottom: 0;
      right: 0;
      background-color: $cl-yellow;
      color: black;
      height: 50px;
      z-index: 2;
      padding: 0 8px 0 0;
      font-size: 30px;
      font-weight: bold;
      letter-spacing: 2.8px;
      padding-left: 2px;

      & .after {
        display: block;
        position: absolute;
        top: 0;
        left: 1px;
        transform: translateX(-100%);
        z-index: 1;
      }
    }
  }

  &--infos {
    --gap: 10px;
    display: flex;
    gap: var(--gap);
    flex-direction: column;
    h4, h5  {
      text-transform: uppercase;
      font-weight: bold;
      font-size: 20px;
      line-height: 2.2rem;
      margin-inline: auto;
      max-width: 300px;
    }
    h5 {
      margin-top: calc(-1 * var(--gap));
    }
    span {
      font-family: $secondaryFont;
      font-size: 12px;
      font-weight: normal;
      text-transform: none;
    }
  }
}
</style>
